import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssueTypesRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-types-view',
	path: '/jira/settings/issues/issue-types',
};
